module.exports = __webpack_public_path__ + "img/bory-logo.ed9eb506.svg";